import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Backdrop, CircularProgress, Container, Typography, WithStyles, withStyles } from "@material-ui/core";
import { styles } from "./BasketView.styles";
import * as CreditCardAction from "../../stores/payment/CreditCardAction";
import * as BasketAction from "../../stores/basket/BasketAction";
import { useAuthContext } from "../../auth/AuthProvider";
import { BasketViewAddress } from "./BasketViewAddress";
import { BasketViewOverview } from "./BasketViewOverview";
import * as UserDetailsAction from "../../stores/user/UserDetailsAction";
import { useHistory, useParams } from "react-router-dom";
import { BlueButton } from "../components/Buttons/BlueButton";

export interface IBasketSuccessViewProps extends WithStyles<typeof styles> {
}

const BasketSuccessViewPure: React.FunctionComponent<IBasketSuccessViewProps> = ({classes}) => {

    const dispatch = useDispatch();
    const authContext = useAuthContext();
    const userId = authContext?.user?.id;

    const {orderId} = useParams();

    let checkStatusPayment = React.useRef(null);
    const [orderPlacedState, setOrderPlacedState] = React.useState(null);

    const paymentId = String(localStorage.getItem("paymentId"));
    const basket = JSON.parse(localStorage.getItem("basket-checkout"));

    const [checkoutRequestErrorState, setCheckoutRequestErrorState] = React.useState(null);

    let paymentMethod = "BankTransfer";
    if (paymentId !== "null") {
        paymentMethod = "Card";
    }

    useEffect(() => {
        dispatch(BasketAction.deleteBackendAcceptancePayment());
        if (paymentId !== "null") {
            dispatch(CreditCardAction.checkStatusPayment(paymentId))
                .then(checkStatusPayment.current = true)
                .catch(
                    e => {
                        setPaymentErrorMessageState(e.message)
                    }
                );
        } else {
            dispatch(BasketAction.checkOut(userId))
                .then(
                    (res) => {
                        setOrderPlacedState(true);
                        dispatch(BasketAction.requestBasket(userId));
                    }
                )
                .catch(
                    e => {
                        setOrderPlacedState(false);
                        setCheckoutRequestErrorState(e.message);
                    }
                );
        }
        if (userId) {
            dispatch(UserDetailsAction.requestCurrentUser(userId));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //do this only when the component is mounted

    const paymentSuccessful = useSelector((state) => state.payment.paymentStatus?.isSuccess);
    const userDetails = useSelector(state => state.userDetails?.currentlyLoggedUser);

    let paymentErrorMessage = useSelector((state) => state.payment.paymentStatus?.message.merchant);
    const [paymentErrorMessageState, setPaymentErrorMessageState] = React.useState(paymentErrorMessage);

    useEffect(() => {
        if (userId !== undefined) {
            if (paymentMethod === "Card") {
                if (paymentSuccessful) {
                    if (checkStatusPayment.current === true) {
                        checkStatusPayment.current = false;
                        localStorage.removeItem("paymentId");
                        setPaymentErrorMessageState("");
                        setOrderPlacedState(true);
                        dispatch(BasketAction.requestBasket(userId)).then((res) => dispatch(BasketAction.deleteBackendAcceptancePayment()));
                    }
                } else {
                    if (orderPlacedState !== true) {
                        setOrderPlacedState(false);
                    }
                }
            }
        }
    }, [dispatch, userId, paymentMethod, paymentSuccessful, orderPlacedState]);

    const history = useHistory();
    const handleReturnToBasket = () => {
        localStorage.removeItem("basket-checkout");
        history.push("/basket/3");
    };

    useEffect(() => {
        if ((paymentMethod === "Card" && paymentSuccessful === false) || checkoutRequestErrorState) {
            setTimeout(() => history.push("/basket/3"), 10000);
        }
    }, [paymentMethod, paymentSuccessful, history, checkoutRequestErrorState]);

    const handleReturnToProducts = () => {
        localStorage.removeItem("basket-checkout");
        history.push("/products");
    };

    if (userId === undefined) return null
    return <Container>
        {((paymentMethod === "Card") && (paymentSuccessful !== undefined)) || (paymentMethod !== "Card") 
        ? <div>
        {orderPlacedState === true
            ? <div>
                <div className={classes.title}>
                    <Typography className={classes.topMargin} variant="h2">Confirmation</Typography>
                </div>
                <Typography variant="h3">Thank you for your order.</Typography>
                <Typography variant="h4">The order is placed now. Your order ID is {orderId}. We will send you this confirmation
                    as an e-mail shortly.</Typography>

                <BlueButton onClick={handleReturnToProducts}>Go to the product page</BlueButton>

                <Typography variant="body1">Here you can reveiw your order:</Typography>
                <BasketViewAddress userDetails={userDetails} buttons={false} />
                <BasketViewOverview basket={basket} buttons={false} userId={userId} orderDetails={basket} handleOrderChange={null} comment={true} />
            </div>
            : <div>{orderPlacedState === false
                ? <div>
                    <div className={classes.title}>
                        <Typography className={classes.topMargin} variant="h2">Problem with displaying this order.</Typography>
                    </div>
                    {((paymentMethod === "Card") && (paymentErrorMessageState !== undefined))
                        ? <div>
                            <Typography variant="h3">The problem with your payment occured:</Typography>
                            <Typography className={classes.paymentError}>{paymentErrorMessageState}</Typography>
                        </div>
                        : <Typography variant="h3">Please contact our support team.</Typography>
                    }
                    {checkoutRequestErrorState &&
                        <div>
                            <Typography variant="h3">Your order could not be placed.</Typography>
                            <Typography className={classes.paymentError}>{checkoutRequestErrorState}</Typography>
                        </div>
                    }
                    <Typography variant="body1">You will be redirected back to the basket automatically within several seconds.</Typography>
                    <BlueButton onClick={handleReturnToBasket}>Return to basket now</BlueButton>
                </div>
                : null
            } </div>
        }
        </div> : null}

        <Backdrop
            style={{ color: '#fff', zIndex: 1000 }}
            open={(paymentMethod === "Card") && (paymentSuccessful === undefined)}
        >
            <CircularProgress color="inherit" />
        </Backdrop>

    </Container>;
};

export const BasketSuccessView = withStyles(styles)(BasketSuccessViewPure);
